import actionCreatorFactory from 'typescript-fsa';
import { reducerWithInitialState } from 'typescript-fsa-reducers';
//const authentication = require('react-azure-adb2c').default;
//import { Dispatch } from 'redux';


import { call, put, takeEvery, select } from 'redux-saga/effects';
// import * as RentContractMoniesApi from '../Api/RentContractMoniesApi';
// import * as RentContractAccountingApi from '../Api/RentContractAccountingApi.ts_';
import * as rent_transfer_accounts_api from '../Api/rent_transfer_accounts_api';
// import * as UsersApi from './Api/UsersApi';
// import * as RentAgentsApi from './Api/RentAgentsApi';

///types
var moment = require("moment");

//export interface HogeState {
//    responselist: string[];
//    responseedit: number;
//}
export interface RentContractMoniesState {
    // rent_contract_monies:any;
    // kyousais: any;
    // search_id: number;
    // search_detail: any;
    // search_modal: boolean;
    // grid_update: boolean;
    transfer_loading: boolean;
    // search_list: any;
    rent_transfer_accounts: any;
    rent_transfer_accounts_search: any;
    application_transfer_accounts:any;
    registration_transfer_accounts:any;
    transfer_modal: boolean;

}
const initialState: RentContractMoniesState = {

    // rent_contract_monies: [],
    // kyousais: [],
    // search_id: 0,
    // search_detail: {},
    // search_modal: false,
    // grid_update: false,
    transfer_loading: false,
    rent_transfer_accounts_search: { name: "", tatemono_name: "", shori_start_date: null, shori_end_date: null, contract_start_date: null, contract_end_date: null, input_start_date: null, input_end_date: null, checked: false },
    rent_transfer_accounts: [],
    transfer_modal: false,
    registration_transfer_accounts:[],
    application_transfer_accounts: [{
        "state":'',
        "web_account_transfer_id": '',
        "bank_handling_number": '',
        "bank_code": '',
        "shop_code": '',
        "deposit_kind": '',
        "account_number": '',
        "account_name_katakana": '',
        "status": '',
        "result_code": '',
        "account_transfer_receipt_number":'',
        "free_tatemono_name": '',
        "free_room_name": '',
        "free_kouza_reason": '',
        "free_name": ''}],
    // rentAgents: [],
    // rentMReasons: [],



}



///action 
const actionCreator = actionCreatorFactory();

// export const get_rent_contract_monies = actionCreator<{rent_contract_id:number}>('GET_RENT_CONTRACT_MONIES');
// export const get_rent_contract_monies_success = actionCreator("GET_RENT_CONTRACT_MONIES_SUCCESS");
// export const get_rent_contract_monies_failure = actionCreator("GET_RENT_CONTRACT_MONIES_FAILURE");

// export const get_rent_contract_accounting = actionCreator("GET_RENT_CONTRACT_ACCOUNTING");


export const get_rent_transfer_accounts = actionCreator('GET_RENT_TRANSFER_ACCOUNTS');
export const change_rent_transfer_accounts = actionCreator("CHANGE_RENT_TRANSFER_ACCOUNTS");


export const delete_rent_transfer_accounts = actionCreator('DELETE_RENT_TRANSFER_ACCOUNTS');


export const update_rent_transfer_accounts = actionCreator('UPDATE_RENT_TRANSFER_ACCOUNTS');

export const new_rent_transfer_accounts = actionCreator('NEW_RENT_TRANSFER_ACCOUNTS');

export const registration_rent_transfer_accounts = actionCreator('NEW_REGISTRATION_TRANSFER_ACCOUNTS');

export const change_transfer_loading = actionCreator<boolean>('CHANGE_TRANSFER_LOADING');

export const change_rent_transfer_accounts_search = actionCreator<boolean>('CHANGE_RENT_TRANSFER_ACCOUNTS_SEARCH');

export const change_transfer_modal = actionCreator<boolean>('CHANGE_TRANSFER_MODAL');

export const change_application_transfer_accounts = actionCreator<boolean>('CHANGE_APPLCATION_TRANSFER_ACCOUNTS');

export const change_registration_transfer_accounts = actionCreator<boolean>('CHANGE_REGISTRATION_TRANSFER_ACCOUNTS');
// export const update_kyousai_comp = actionCreator('UPDATE_KYOUSAI_COMP');
// export const upload_kyousai_csv = actionCreator<any>('UPLOAD_KYOUSAI_CSV');
// // export const get_banks_failure = actionCreator("GET_BANKS_FAILURE");

// export const change_search_id = actionCreator<number>("CHANGE_SEARCH_ID");

// export const change_search_modal = actionCreator<boolean>("CHANGE_SEARCH_MODAL");

// export const change_grid_update = actionCreator<boolean>("CHANGE_GRID_UPDATE");

// export const change_csv_loading = actionCreator<boolean>("CHANGE_CSV_LOADING");

// export const change_search_detail = actionCreator<any>("CHANGE_SEARCH_DETAIL");


// export const change_search_list = actionCreator<any>("CHANGE_SEARCH_LIST");

// export const matching = actionCreator<any>("MATCHNG");

// export const delete_kyousais = actionCreator<any>("DELETE_KYOUSAIS");

// export const all_select = actionCreator<any>("ALL_SELECT");

// export const get_kyousais_csv = actionCreator<any>("GET_KYOUSAIS_CSV");


// export const getRentAgents = actionCreator('RENT_AGENTS_REQUEST');
// export const getRentAgentsSuccess = actionCreator("RENT_AGENTS_SUCCESS");
// export const getRentAgentsFailure = actionCreator("RENT_AGENTS_FAILURE");


// export const getRentMReasons = actionCreator('RENT_M_REASONS_REQUEST');
// export const getRentMReasonsSuccess = actionCreator("RENT_M_REASONS_SUCCESS");
// export const getRentMReasonsFailure = actionCreator("RENT_M_REASONS_FAILURE");


export const transferReducer = reducerWithInitialState(initialState)
    .case(change_rent_transfer_accounts, (state, payload) => ({ ...state, rent_transfer_accounts: payload }))

    
    .case(change_transfer_modal, (state, payload) => ({ ...state, transfer_modal: payload }))

    .case(change_transfer_loading, (state, payload) => ({ ...state, transfer_loading: payload }))

    .case(change_rent_transfer_accounts_search, (state, payload) => ({ ...state, rent_transfer_accounts_search: payload }))
    .case(change_application_transfer_accounts, (state, payload) => ({ ...state, application_transfer_accounts: payload }))
    .case(change_registration_transfer_accounts, (state, payload) => ({ ...state, registration_transfer_accounts: payload }))


// .case(change_search_modal, (state, payload) => ({ ...state, search_modal: payload }))

// .case(change_grid_update, (state, payload) => ({ ...state, grid_update: payload }))

// .case(change_csv_loading, (state, payload) => ({ ...state, csv_loading: payload }))

// .case(change_search_detail, (state, payload) => ({ ...state, search_detail: payload }))

// .case(change_search_list, (state, payload) => ({ ...state, search_list: payload }))


// .case(get_rent_contract_monies_success, (state, payload) => ({ ...state, rent_contract_monies: payload }));



//.case(getRentMMedeasFailure, (state, payload) => ({ ...state, rentMMedeas: payload }))
// .case(getUsersSuccess, (state, payload) => ({ ...state, users: payload }))
// .case(getUsersFailure, (state, payload) => ({ ...state, users: payload }))
// .case(getRentAgentsSuccess, (state, payload) => ({ ...state, rentAgents: payload }))
// .case(getRentAgentsFailure, (state, payload) => ({ ...state, rentAgents: payload }))
// .case(getRentMReasonsSuccess, (state, payload) => ({ ...state, rentMReasons: registration_transfer_accountsayload }))
// .case(getRentMReasonsFailure, (state, payload) => ({ ...state, rentMReasons: payload }));







// 「LOGIN_REQUEST」アクションが呼ばれるのを待つ呼ばれたhandleRequestを実行
export const transferSaga = [
    //     takeEvery('GET_RENT_CONTRACT_MONIES', handleRequestMoney),
    // takeEvery('GET_RENT_CONTRACT_ACCOUNTING', handle_get_rent_contract_accounting),
    takeEvery('GET_RENT_TRANSFER_ACCOUNTS', handle_get_rent_transfer_accounts),
    takeEvery('DELETE_RENT_TRANSFER_ACCOUNTS', handle_delete_rent_transfer_accounts),
    takeEvery('UPDATE_RENT_TRANSFER_ACCOUNTS', handle_update_rent_transfer_accounts),
    takeEvery('NEW_RENT_TRANSFER_ACCOUNTS', handle_new_rent_transfer_accounts),
    takeEvery('NEW_REGISTRATION_TRANSFER_ACCOUNTS', handle_registration_rent_transfer_accounts),


    // takeEvery('UPLOAD_KYOUSAI_CSV', handle_upload_kyousai_csv),
    // takeEvery('MATCHNG', handle_matching),
    // takeEvery('DELETE_KYOUSAIS', handle_delete_kyousais),
    // takeEvery('ALL_SELECT', handle_all_select),
    // takeEvery('GET_KYOUSAIS_CSV', handle_get_kyousais_csv),

    // takeEvery('RENT_M_REASONS_REQUEST', handleRentMReasonsRequest),
];
// export default masterSaga;





// function* handle_get_rent_contract_accounting(action:any) {

//     const { payload, error }= yield call(RentContractAccountingApi.list, action.payload);

//        // サーバーからのレスポンスデータによる分岐処理
//        if (payload && !error) {
//            // 成功時アクション呼び出し
//        console.log(payload)
//        const a = document.createElement('a');
// // ダウンロードされるファイル名
// a.download = "会計.csv";
// a.href = URL.createObjectURL(payload);
// // ダウンロード開始
// a.click();
//     //    yield put(get_rent_contract_monies_success(payload));

//        } else {
//        //    // 失敗時アクション呼び出し
//        //    yield put(loginFailure(payload));
//        }
//    }



function* handle_get_rent_transfer_accounts(action: any) {
    console.log(action.payload)

    yield put(change_transfer_loading(true));
    const state = yield select();
    let rent_transfer_accounts_search = state.Transfer.rent_transfer_accounts_search
    const { payload, error } = yield call(rent_transfer_accounts_api.list, rent_transfer_accounts_search);

    // サーバーからのレスポンスデータによる分岐処理
    if (payload && !error) {
        console.log(payload)
        let accounts = payload.map(function (value: any) {
              if (value.site === 1) {
   value.site_name = "へやのしおり"
  } else if (value.site === 2) {
         value.site_name = "マイページ"
  } else if (value.site=== 3) {
      value.site_name = "グローバルパーキング"
  } else if (value.site === 4) {
        value.site_name = "スマート切替"
  } else {
      value.site_name = ""
  }
            value.contract_date = value.contract_date ? String(moment(value.contract_date).utc().format("YYYY/MM/DD")) : ""
            value.kakumei_updated_at = value.kakumei_updated_at ? String(moment(value.kakumei_updated_at).utc().format("YYYY-MM-DD HH:mm:ss")) : ""
            value.deleted_at = value.deleted_at ? String(moment(value.deleted_at).utc().format("YYYY/MM/DD HH:mm:ss")) : ""
            value.created_at = value.created_at ? String(moment(value.created_at).utc().format("YYYY/MM/DD HH:mm:ss")) : ""
            value.deposit_kind_name = value.deposit_kind === 1 ? "普通" : ""
            return value
        })
        yield put(change_rent_transfer_accounts(accounts));
        yield put(change_transfer_loading(false));
        //    yield put(get_rent_contract_monies_success(payload));

    } else {

        alert(error)
        //    // 失敗時アクション呼び出し
        //    yield put(loginFailure(payload));
    }
}



function* handle_delete_rent_transfer_accounts(action: any) {
    console.log(action.payload)
    const state = yield select();
    let rent_transfer_accounts = state.Transfer.rent_transfer_accounts
    yield put(change_transfer_loading(true));
    const { payload, error } = yield call(rent_transfer_accounts_api.deletetransfer, { deleted: rent_transfer_accounts.filter((a: any) => a.deleted === 1) });

    // サーバーからのレスポンスデータによる分岐処理
    if (payload && !error) {
        console.log(payload)

        // yield put(change_rent_transfer_accounts(payload));

        yield put(get_rent_transfer_accounts());
        yield put(change_transfer_loading(false));
    } else {

        alert(error)
        //    // 失敗時アクション呼び出し
        //    yield put(loginFailure(payload));
    }
}



function* handle_update_rent_transfer_accounts(action: any) {
    console.log(action.payload)
    const state = yield select();
    let rent_transfer_accounts = state.Transfer.rent_transfer_accounts
    yield put(change_transfer_loading(true));
    const { payload, error } = yield call(rent_transfer_accounts_api.updatekakumei, rent_transfer_accounts.filter((a: any) => a.selected === 1));

    // サーバーからのレスポンスデータによる分岐処理
    if (payload && !error) {
        console.log(payload)

        // yield put(change_rent_transfer_accounts(payload));

        yield put(get_rent_transfer_accounts());
        yield put(change_transfer_loading(false));
    } else {

        alert(error)
        //    // 失敗時アクション呼び出し
        //    yield put(loginFailure(payload));
    }
}

function* handle_new_rent_transfer_accounts(action: any) {
    // try{
    yield put(change_transfer_loading(true));
    console.log(action.payload,"確認")
    yield put(change_transfer_modal(true))
    console.log(action.payload)
    const state = yield select();
    let rent_transfer_accounts = state.Transfer.rent_transfer_accounts
    // yield put();
    const { payload, error } = yield call(rent_transfer_accounts_api.gettransferlist, action.payload);

    // // サーバーからのレスポンスデータによる分岐処理
    if (payload && !error) {
        console.log(payload,"取得データ")
        if(payload.indexOf('前回の処理が終了してから') != -1){
            alert(payload)
        }else{
            yield put(change_application_transfer_accounts(payload));
        }
        // yield put(change_transfer_loading(false));
        yield put(get_rent_transfer_accounts())
        // yield put(change_transfer_loading(false));
    } else {

        alert(error)
        yield put(change_transfer_loading(false));
    }
    // }catch(e){
    //     console.log(e,"エラー")
    // }
}


function* handle_registration_rent_transfer_accounts(action: any) {
    // try{
    yield put(change_transfer_loading(true));
    console.log(action.payload,"確認")
    const { payload, error } = yield call(rent_transfer_accounts_api.applicationregistration, action.payload);

    // // サーバーからのレスポンスデータによる分岐処理
    if (payload && !error) {
        // console.log(payload,"取得データ")
        alert(payload)
        yield put(change_transfer_loading(false));
    } else {

        alert(error)
        yield put(change_transfer_loading(false));
    }
    // }catch(e){
    //     console.log(e,"エラー")
    // }
}
// function* handle_get_kyousais_csv(action: any) {
//     const state = yield select();
//     let search_list = state.kyousaiReducer.search_list
//     const { payload, error } = yield call(KyousaiApi.downloadcsv, search_list);

//     // サーバーからのレスポンスデータによる分岐処理
//     if (payload && !error) {
//         // 成功時アクション呼び出し
//         console.log(payload)
//         const a = document.createElement('a');
//         // ダウンロードされるファイル名
//         a.download = "きょうさい.csv";
//         a.href = URL.createObjectURL(payload);
//         // ダウンロード開始
//         a.click();
//         //    yield put(get_rent_contract_monies_success(payload));

//     } else {
//         //    // 失敗時アクション呼び出し
//         //    yield put(loginFailure(payload));
//     }
// }


// function* handle_update_kyousai_comp(action: any) {
//     yield put(change_csv_loading(true))
//     const state = yield select();
//     let kyousais = state.kyousaiReducer.kyousais
//     // console.log(kyousais)
//     let kyousaisset = kyousais.filter((a: any) => a.select === 1)
//     console.log(kyousaisset)

//     const { payload, error } = yield call(KyousaiApi.update, kyousaisset);

//     if (payload && !error) {
//         // console.log(payload)
//         // alert()
//         yield put(change_kyousais(payload));
//         yield put(change_csv_loading(false))
//         //  yield put(change_kyousais(payload));
//         //    yield put(get_rent_contract_monies_success(payload));

//     } else {

//         alert(error)
//         //    // 失敗時アクション呼び出し
//         //    yield put(loginFailure(payload));
//     }
// }

// function* handle_matching(action: any) {
//     yield put(change_csv_loading(true))

//     const { payload, error } = yield call(KyousaiApi.matching, action.payload);
//     if (payload && !error) {
//         // console.log(payload)
//         // alert()
//         yield put(get_kyousais())
//         yield put(change_csv_loading(false))
//         //  yield put(change_kyousais(payload));
//         //    yield put(get_rent_contract_monies_success(payload));

//     } else {

//         alert(error)
//         //    // 失敗時アクション呼び出し
//         //    yield put(loginFailure(payload));
//     }
// }


// function* handle_delete_kyousais(action: any) {
//     yield put(change_csv_loading(true))
//     const state = yield select();
//     let kyousais = state.kyousaiReducer.kyousais
//     // console.log(kyousais)
//     let kyousaisset = kyousais.filter((a: any) => a.delete === 1)
//     console.log(kyousaisset)

//     const { payload, error } = yield call(KyousaiApi.delete_kyousais, kyousaisset);

//     if (payload && !error) {
//         // console.log(payload)
//         // alert()
//         yield put(change_kyousais(payload));
//         yield put(change_csv_loading(false))
//         //  yield put(change_kyousais(payload));
//         //    yield put(get_rent_contract_monies_success(payload));

//     } else {

//         alert(error)
//         //    // 失敗時アクション呼び出し
//         //    yield put(loginFailure(payload));
//     }
// }





// function* handle_all_select(action: any) {
//     // yield put(change_csv_loading(true))
//     const state = yield select();
//     let kyousais = state.kyousaiReducer.kyousais
//     const count = kyousais.filter((a: any) => a.select === 1).length
//     kyousais = kyousais.map((value: any) => {
//         if (value.receipt_at && value.rent_contract_id) {
//             value.select = count > 0 ? 0 : 1
//         }
//         return value
//     })

//     yield put(change_kyousais(kyousais))
//     yield put(change_grid_update(true));


// }






// function* handleRentMReasonsRequest(action: any) {

//     let { payload } = action;
//     payload = yield call(RentMReasonsApi.RentMReasonsList, payload);

//     // サーバーからのレスポンスデータによる分岐処理
//     //if (ログイン成功か失敗かの条件) {
//     // 成功時アクション呼び出し
//     console.log(payload)

//     yield put(getRentMReasonsSuccess(payload));
//     //} else {
//     //    // 失敗時アクション呼び出し
//     //    yield put(loginFailure(payload));
//     //}
// }